<checkbox name="framework" value="Angular" [(ngModel)]="selectedFramework">Angular</checkbox>
<checkbox name="framework" value="React" [(ngModel)]="selectedFramework">React</checkbox>
<checkbox name="framework" value="Vue" [(ngModel)]="selectedFramework">Vue</checkbox>
